import React from 'react'
import { components, useTranslation } from 'cng-web-lib'
import Namespace from 'src/constants/locale/Namespace'
import PersonDTOFormProperties from './PersonDTOFormProperties'
import { FormProvider, useForm } from 'react-hook-form'
import useCustomYupValidationResolver from '../../../components/aciacehighway/hooks/useCustomYupValidationResolver'
import { Box, Card, Grid, Tooltip } from '@material-ui/core'
import ACIHighwayManifestTranslationText from './../contexts/ACIHighwayManifestTranslationText'

const {
  button: { CngButton, CngIconButton }
} = components

const { initialValues, makeValidationSchema } =
  PersonDTOFormProperties.formikProps

function PersonDTOEntry(props) {
  const {
    onAddPersonDTO,
    onClonePersonDTO,
    onDeletePersonDTO,
    onEditPersonDTO,
    personDTO,
    showNotification,
    index
  } = props

  const aciHighwayManifestTranslationText = ACIHighwayManifestTranslationText()

  return (
    <Card variant='outlined'>
      <Box padding={2}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <PersonDTOFormProperties.Fields showNotification={showNotification} index={index}/>
          </Grid>
          <Grid item xs={12}>
            <Grid container justify='space-between' spacing={2}>
              <Grid item xs='auto'>
                <Grid container spacing={1}>
                  <Grid item xs='auto'>
                    <Tooltip placement='bottom' title={aciHighwayManifestTranslationText.addNewLabel}>
                      <span>
                        <CngIconButton
                          icon={['fal', 'plus']}
                          onClick={() => onAddPersonDTO(initialValues)}
                          size='small'
                          type='outlined'
                        />
                      </span>
                    </Tooltip>
                  </Grid>
                  <Grid item xs='auto'>
                    <Tooltip placement='bottom' title={aciHighwayManifestTranslationText.cloneLabel}>
                      <span>
                        <CngIconButton
                          icon={['fal', 'copy']}
                          onClick={() => onClonePersonDTO(personDTO)}
                          size='small'
                          type='outlined'
                        />
                      </span>
                    </Tooltip>
                  </Grid>
                  <Grid item xs='auto'>
                    <Tooltip placement='bottom' title={aciHighwayManifestTranslationText.deleteLabel}>
                      <span>
                        <CngIconButton
                          icon={['fal', 'trash']}
                          onClick={() => onDeletePersonDTO(personDTO)}
                          size='small'
                          type='outlined'
                        />
                      </span>
                    </Tooltip>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </Card>
  )
}

export default PersonDTOEntry
